module.exports = __webpack_public_path__ + "img/hover_card_beca_estatus_pago.f40c9fdf.svg";